import { FC } from "react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

export interface ErrorFallbackProps {
  errorId?: string;
  onRetry?: () => void;
  onGoHome?: () => void;
  className?: string;
}

const ErrorFallback: FC<ErrorFallbackProps> = ({
  errorId,
  onRetry,
  onGoHome,
  className,
}) => {
  const goHome = onGoHome ?? ((): void => {
    window.location.hash = "#/";
    window.location.reload();
  });

  return (
    <div
      className={cn(
        "flex min-h-[50vh] flex-col items-center justify-center gap-6 p-6",
        className
      )}
    >
      <div className="flex max-w-md flex-col items-center gap-4 text-center">
        <h1 className="text-xl font-semibold text-foreground">
          Une erreur inattendue est survenue
        </h1>
        <p className="text-sm text-muted-foreground">
          Pour votre sécurité, certaines opérations ont été interrompues.
          Veuillez réessayer ou contacter le support si le problème persiste.
        </p>
        {errorId && (
          <p className="text-xs text-muted-foreground" data-testid="error-id">
            Code d&apos;erreur : {errorId}
          </p>
        )}
      </div>
      <div className="flex flex-wrap items-center justify-center gap-3">
        <Button
          onClick={goHome}
          variant="default"
          data-testid="error-go-home"
        >
          Revenir à l&apos;accueil
        </Button>
        {onRetry && (
          <Button
            onClick={onRetry}
            variant="outline"
            data-testid="error-retry"
          >
            Réessayer
          </Button>
        )}
        <Button
          variant="ghost"
          asChild
          data-testid="error-support"
        >
          <a
            href="tel:0800000000"
            className="inline-flex items-center justify-center gap-2"
          >
            Contacter le support
          </a>
        </Button>
      </div>
    </div>
  );
};

export default ErrorFallback;
